import type { User } from '@/shared/types/user';
import { USER_ROLE } from '@/shared/types/user';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/shared/ui/tabs';
import { Text } from '@/shared/ui/text';
import type { TabItem } from '../model/schemas';
import { EnvironmentSettingsTab } from './environment-settings-tab';
import { PersonalSettingsTab } from './personal-settings-tab';
import { UserManagementTab } from './user-management-tab';

interface SettingsClientProps {
  readonly user: Omit<User, 'is_confirmed'>;
  readonly filteredTabItems: readonly TabItem[];
}

export function SettingsClient({ user, filteredTabItems }: SettingsClientProps) {
  const isAdmin = user.role === USER_ROLE.ADMIN;

  return (
    <div className="w-full h-full flex flex-col p-7 space-y-2">
      <header className="flex flex-col gap-2 shrink-0">
        <Text
          tag="h1"
          typography="typo-title-m-bold"
        >
          설정
        </Text>
        <Text
          className="text-muted-foreground"
          typography="typo-text-xl"
        >
          사용자 관리와 시스템 환경설정을 할 수 있습니다.
        </Text>
      </header>

      <Tabs
        className="w-full flex-1 min-h-0 flex flex-col space-y-2"
        defaultValue={filteredTabItems[0].value}
      >
        <TabsList className="bg-accent mt-6 w-fit shrink-0">
          {filteredTabItems.map((item: TabItem) => (
            <TabsTrigger
              key={item.value}
              value={item.value}
            >
              {item.label}
            </TabsTrigger>
          ))}
        </TabsList>
        {isAdmin && (
          <TabsContent
            className="flex-1 mt-6 gap-3 relative flex flex-col min-h-0"
            value={'user-management'}
          >
            <UserManagementTab />
          </TabsContent>
        )}

        <TabsContent
          className="flex-1 mt-6 gap-3 relative flex flex-col space-y-6"
          value={'environment-settings'}
        >
          {isAdmin && <EnvironmentSettingsTab />}
          <PersonalSettingsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
